/**
 * 
 * key
 * 
 */


const key = 'cmVwb3J0aW5ndG8='

export default key 